import { jsx as e, Fragment as i, jsxs as a } from "react/jsx-runtime";
import '../Divider.css';const s = "_dividerWrapper_451le_1", t = "_divider_451le_1", c = "_text_451le_11", r = {
  dividerWrapper: s,
  divider: t,
  text: c
}, n = ({ text: d }) => /* @__PURE__ */ e(i, { children: d ? /* @__PURE__ */ a("div", { className: r.dividerWrapper, "data-cxy-name": "divider", children: [
  /* @__PURE__ */ e("hr", { className: r.divider }),
  /* @__PURE__ */ e("span", { className: r.text, children: d }),
  /* @__PURE__ */ e("hr", { className: r.divider })
] }) : /* @__PURE__ */ e("hr", { className: r.divider, "data-cxy-name": "divider" }) });
export {
  n as Divider
};
